import axios from 'axios';
export function Section(id) {
    return axios.get(process.env.REACT_APP_API + "/api/sections/get.php?id=" + id);
}